<template>
  <footer class="py-4 bottom-0" style="background-color: #3F403E;">
    <div class="container mx-auto px-4">
      <p class="text-sm text-center text-white">© 2024 CAPER SHOW. Todos los derechos reservados.</p>
    </div>
  </footer>
</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'FooterSection',
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },
}

</script>